import { render, staticRenderFns } from "./ScheduleMatchCenter.vue?vue&type=template&id=55b428ca&scoped=true&"
import script from "./ScheduleMatchCenter.vue?vue&type=script&lang=js&"
export * from "./ScheduleMatchCenter.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleMatchCenter.vue?vue&type=style&index=0&id=55b428ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b428ca",
  null
  
)

export default component.exports